module.exports = __webpack_public_path__ + "static/media/solution-ic-1.8cd7a815.svg";